import { RouteProps, Route } from "react-router-dom"
import { Authority, useAuthenticated } from "providers/A12n"
import { Unauthorized } from "components/Unauthorized"

type Props = RouteProps & {
  allowed: Authority[]
}

export function AuthorizedRoute({ allowed, ...rest }: Props) {
  const { hasAuthority } = useAuthenticated()

  return hasAuthority(allowed) ? <Route {...rest} /> : <Unauthorized />
}
